import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
// import apiMiddleware from "./middleware/api";

export default configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => [
        ...getDefaultMiddleware({ serializableCheck: false, immutableCheck: { ignore: ["user"] } }),
    ],
});

// const store = currentUser =>
//     configureStore({
//         preloadedState: { user: { currentUser, authErrorMessage: "" } },
//         reducer: rootReducer,
//         middleware: getDefaultMiddleware => [
//             ...getDefaultMiddleware({ serializableCheck: false, immutableCheck: { ignoredPaths: ["user"] } }),
//         ],
//     });

// export default store;
